import React from 'react';
import { Alert } from 'antd';
import { FormattedMessage } from 'react-intl';

const HELP_LINK =
	'http://ajuda.br24.io/?utm_source=powerzap&utm_medium=boas-praticas&utm_campaign=banimento';

const GoodHabitsAlert = ({ onClose }) => (
	<Alert
		message={
			<FormattedMessage
				id="alert_good_habits"
				values={{
					link: (
						<a href={HELP_LINK} target="_blank" rel="noopener noreferrer">
							<FormattedMessage id="click_here" />
						</a>
					),
				}}
			/>
		}
		type="info"
		showIcon
		closable
		onClose={onClose}
	/>
);

export default GoodHabitsAlert;
